import React from "react";

export const Header1 = (props) => {
  const calendlyLink = "https://calendly.com/rashid-a";

  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text">
                <h1>
                  {props.data ? props.data.title : "Loading"}
                  <span></span>
                </h1>
                <p>{props.data ? props.data.paragraph : "Loading"}</p>
                <a
                  href={calendlyLink} 
                  className="btn btn-custom btn-lg page-scroll"
                  target="_blank" // to open link in new tab
                  rel="noopener noreferrer" // for security reasons
                >
                  Book A Free Demo
                </a>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
